'use client';

import React, { type FC, useEffect, useState } from 'react';

import type { PodcastConfigProps } from 'molecules/Podcast/config';

const PodcastPlayer: FC<PodcastConfigProps> = ({ embed }) => {
  const [cleanEmbedCode, setCleanEmbedCode] = useState<string>('');

  useEffect(() => {
    if (!embed) {
      return;
    }

    import('dompurify').then(DOMPurify => {
      const purify = DOMPurify.default;

      purify.addHook('afterSanitizeAttributes', node => {
        if ('tagName' in node && node.tagName.toLowerCase() === 'script') {
          const src = node.getAttribute('src');
          if (src) {
            try {
              const parsedSrc = new URL(src);
              if (parsedSrc.protocol !== 'https:' || parsedSrc.hostname !== 'soundcloud.com') {
                node.remove();
              }
            } catch {
              node.remove();
            }
          }
        }
      });

      setCleanEmbedCode(purify.sanitize(embed, { FORCE_BODY: true, ADD_TAGS: ['iframe'] }));
    });
  }, [embed]);

  if (!embed || !cleanEmbedCode) {
    return null;
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: cleanEmbedCode,
      }}
    />
  );
};

export default PodcastPlayer;
